export type DashboardFeatureAnnouncement = {
    id: string;
    title: string;
    description: string;
    actionLabel: string;
    actionPath: string;
    publishedAt: string;
    visibleForDays: number;
};

const millisecondsPerDay = 24 * 60 * 60 * 1000;

export const dashboardFeatureAnnouncements: DashboardFeatureAnnouncement[] = [
    {
        id: "coverage-opportunities-report-2026-07",
        title: "Find gaps in your fitment coverage",
        description: "Discover high-demand vehicle searches with few or no current product mappings, then use those insights to prioritize catalog expansion.",
        actionLabel: "View coverage opportunities",
        actionPath: "/reports?report=coverage_opportunities",
        publishedAt: "2026-07-29T00:00:00-05:00",
        visibleForDays: 90,
    },
];

export const getLatestDashboardFeatureAnnouncement = (
    dismissedAnnouncementId?: string,
    now = new Date()
) => dashboardFeatureAnnouncements
    .filter((announcement) => {
        if (announcement.id === dismissedAnnouncementId) {
            return false;
        }

        const publishedAt = new Date(announcement.publishedAt);
        if (Number.isNaN(publishedAt.getTime())) {
            return false;
        }

        const ageInMilliseconds = now.getTime() - publishedAt.getTime();
        return ageInMilliseconds >= 0
            && ageInMilliseconds < announcement.visibleForDays * millisecondsPerDay;
    })
    .sort((left, right) => (
        new Date(right.publishedAt).getTime() - new Date(left.publishedAt).getTime()
    ))[0];
